var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"m-1 player-pill",attrs:{"variant":_vm.variant},on:{"click":function($event){return _vm.$emit('show-player-modal', _vm.name)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }